import { useMemo } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../lib/database';

export const useSyncableForms = () => {
  const outboxItems = useLiveQuery(() => db.outbox.toArray(), []);
  const localForms = useLiveQuery(() => db.forms.toArray(), []);

  const formsToSync = useMemo(() => {
    if (!localForms || !outboxItems) return [];

    const pendingCounts = outboxItems.reduce((acc, item) => {
      const formId = String(item.payload?.form_id);
      if (formId) {
        acc[formId] = (acc[formId] || 0) + 1;
      }
      return acc;
    }, {});

    const formIdToTitleMap = localForms.reduce((acc, form) => {
        acc[String(form.id)] = { title: form.title, description: form.description };
        return acc;
    }, {});

    return Object.keys(pendingCounts)
      .map(formId => {
        const formDetails = formIdToTitleMap[formId];
        if (!formDetails) return null;
        return {
          id: formId,
          title: formDetails.title,
          description: formDetails.description,
          pendingCount: pendingCounts[formId],
        };
      })
      .filter(Boolean)
      .sort((a, b) => b.pendingCount - a.pendingCount);
  }, [localForms, outboxItems]);

  const totalPendingCount = useMemo(() => (outboxItems || []).length, [outboxItems]);
  
  const isLoading = outboxItems === undefined || localForms === undefined;

  return {
    formsToSync,
    totalPendingCount,
    outboxItems,
    isLoading,
  };
};